import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";  
import usePharmacyList from "./hooks/usePharmacyList"; 
  
const PharmacyList = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  selectParamsData,
}) => {
  const pharmacyListData = usePharmacyList(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    selectParamsData
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection ctaButtons={pharmacyListData.leftButtons} align="left" />
      <div className="header-section">
        <h1>
          {pharmacyListData.screen_title} -{" "}
          <span className="heading-cod">{pharmacyListData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={pharmacyListData.formFields}
        dropdownValues={pharmacyListData.dropdownValues}
        paramsData={pharmacyListData.paramsData}
        updataParamData={pharmacyListData.updateParamData}
      />
      <ButtonsSection ctaButtons={pharmacyListData.ctaButtons} />
      <DisplayTable
        selectMode={pharmacyListData.selectMode}
        data={pharmacyListData.data}
        parmKey={pharmacyListData.parmKey}
        menuOptions={pharmacyListData.menuOptions}
        tableHeaders={pharmacyListData.columnDef}
        setRowData={pharmacyListData.setRowData}
        selectedPriceSchedules={pharmacyListData.selectedRows}
        setSelectedPriceSchedules={pharmacyListData.setSelectedRows}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={pharmacyListData.first}
          rows={pharmacyListData.rows}
          totalRecords={pharmacyListData.totalRecords}
          currentPage={pharmacyListData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={pharmacyListData.onPageChange}
        />
      </div>
      {pharmacyListData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={pharmacyListData.isConfirmationModalOpen}
          onRequestClose={pharmacyListData.closeConfirmationModal}
          onBack={pharmacyListData.closeConfirmationModal}
          onSave={pharmacyListData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={pharmacyListData.setSelectedOption}
        />
      )}
    </div>
  );
};  
  
export default PharmacyList;  
 
